import React from 'react';
import { signIn } from 'aws-amplify/auth';
import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';

import useStyles from './amplify-auth-widget.styles';

import '@aws-amplify/ui-react/styles.css';
import './amplify-styles-override.css';

const AmplifyAuthWidget = () => {
  const classes = useStyles();
  return (
    <Authenticator.Provider>
      <Authenticator
        services={{
          async handleSignIn(signInInput) {
            return signIn({
              username: signInInput.username,
              password: signInInput.password,
              options: {
                authFlowType: 'CUSTOM_WITH_SRP'
              }
            });
          }
        }}
        components={{
          SignIn: {
            Header() {
              return (
                <div className="header">
                  <h3 className="amplify-heading amplify-heading--3">Sign in to your account</h3>
                </div>
              );
            },
            Footer() {
              const { toForgotPassword } = useAuthenticator();
              return (
                <div className={classes.amplifyWidgetFooter}>
                  <button className="resetPasswordBtn" onClick={toForgotPassword}>
                    Forgot your password?
                  </button>
                </div>
              );
            }
          }
        }}
        hideSignUp
        formFields={{
          signIn: {
            username: {
              label: 'Email *',
              isRequired: true,
              placeholder: 'Enter your email'
            },
            password: {
              label: 'Password *',
              placeholder: 'Enter your password',
              isRequired: true
            }
          },
          forgotPassword: {
            username: {
              label: 'Email *',
              isRequired: true
            }
          }
        }}
      />
    </Authenticator.Provider>
  );
};

export default AmplifyAuthWidget;
